var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Typography as TypographyMui } from '@mui/material';
import React from 'react';
import styles from './Typogpaphy.module.scss';
import classNames from 'classnames';
export function Typography(_a) {
    var { children, classes, variant, gutterBottom } = _a, props = __rest(_a, ["children", "classes", "variant", "gutterBottom"]);
    return (_jsx(TypographyMui, Object.assign({ variant: variant, className: classNames(styles.wrapper, styles[variant], classes), gutterBottom: gutterBottom }, props, { children: children })));
}
